import { useEffect } from "react";
import { normalizeRating } from "../utils/InputRatingUtils";

const useHydrateRatings = ({
    derivedExistingRatingsData,
    existingStudentComments,
    groupData,
    mode,
    setComments,
    setRatings,
    setRatingsLoaded
}) => {
    useEffect(() => {
        if (!derivedExistingRatingsData || derivedExistingRatingsData.length === 0) return;
        if (mode === "GROUPS" && !derivedExistingRatingsData[0].key.includes("-")) return;
        if (mode !== "GROUPS" && derivedExistingRatingsData[0].key.includes("-")) return;

        const hydratedRatings = {};
        derivedExistingRatingsData.forEach((studentRating) => {
            const studentId = studentRating.key;
            studentRating.contentRatings.forEach((rating) => {
                const key = `${studentId}_${rating.templateContentId}`;
                hydratedRatings[key] = normalizeRating(rating.rating);
            });
        });
        setRatings(hydratedRatings);
        setRatingsLoaded(true);

        const hydratedComments = {};
        existingStudentComments.forEach((studentComment) => {
            const studentId = studentComment.gradingProfileStudentId;
            const gradingCriteria = studentComment.gradingCriteria;
            let key = `${studentId}_${gradingCriteria}`;

            if (mode === "GROUPS") {
                const matchingGroup = groupData?.find((group) =>
                    group.groupStudentContents.some(
                        (s) => s.gradingProfileStudentId?.toString() === studentId?.toString()
                    )
                );
                if (matchingGroup) {
                    const groupKeyPrefix = `${matchingGroup.groupId}-${studentId}`;
                    key = `${groupKeyPrefix}_${gradingCriteria}`;
                }
            }

            hydratedComments[key] = studentComment.comment || "";
        });
        setComments(hydratedComments);
    }, [
        derivedExistingRatingsData,
        existingStudentComments,
        groupData,
        mode,
        setRatings,
        setComments,
        setRatingsLoaded
    ]);
};

export default useHydrateRatings;
